import Shareds from "@/assets/js/shared";
const shared = new Shareds()
class D_LocalStorage {

    constructor(){
        this.storageKey = 'dcp-dentLab-token'
    }

    saveUserInfoToLocalStorage(userObj){
        //先加密成加密資料
        const tokenForUserData = shared.encryptionUserInfo(userObj)
        console.log(`tokenForUserData=` , tokenForUserData)
        localStorage.setItem(this.storageKey, tokenForUserData )
        return tokenForUserData
    }

    getUserInfoToLocalStorage(){
        const tokenForUserData = localStorage.getItem(this.storageKey) ? localStorage.getItem(this.storageKey) : null
        if (!tokenForUserData) return null
        const userData = shared.decryption(tokenForUserData)
        return userData ? userData : null
    }
}
export default D_LocalStorage